<template>
    <div class="addContract">
        <van-row class="cell">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">客户名称</van-col>
                <van-col span="16" class="rightText">
                    <van-field
                        v-model="customerName"
                        @input="filterEmoji"
                        maxlength="50"
                        @focus="beginSearch"
                        @blur="endSearch"
                        autocomplete="off"
                    />
                </van-col>
                <van-col span="24">
                    <ul class="customer-list" v-show="customerList.length > 0 && customerNameEdit">
                        <li
                            class="customer-item"
                            v-for="customer in customerList"
                            :key="customer.customerId"
                            @click="selectCustomer(customer)"
                        >{{customer.customerName}}</li>
                    </ul>
                </van-col>
            </van-row>
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">联系人</van-col>
                <van-col span="16" class="rightText">
                    <van-field :disabled="connectInputDisabled" v-model="connectName" @input="filterEmoji" maxlength="30"/>
                </van-col>
            </van-row>
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">联系电话</van-col>
                <van-col span="16" class="rightText">
                    <van-field :disabled="connectInputDisabled" v-model="connectPhone" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell type">
            <van-row class="border cell-body">
                <van-col span="8" class="title">服务类型</van-col>
                <van-col span="16" class="rightText pdr1">
                    <div>
                        <zwySelect
                            placeHolder="请选择服务类型"
                            @selectListItem="handleSelectServiceType"
                            :contentText="selectServiceType.text"
                            :arrow="true"
                        ></zwySelect>
                    </div>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell">
            <van-row class="border cell-body">
                <van-col span="8" class="title">服务项目</van-col>
                <van-col span="16" class="rightText pdr1">
                    <div>
                        <zwySelect
                            placeHolder="请选择服务项目"
                            @selectListItem="handleSelectServiceItem"
                            :contentText="selectServiceItem.text"
                            :arrow="true"
                        ></zwySelect>
                    </div>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell">
            <van-row class="border cell-body">
                <van-col span="8" class="title">收款方式</van-col>
                <van-col span="16" class="rightText pdr1">
                    <div>
                        <zwySelect
                            placeHolder="请选择收款方式"
                            @selectListItem="handleSelectCollectionType"
                            :contentText="selectCollectionType.text"
                            :arrow="true"
                        ></zwySelect>
                    </div>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct'" class="cell">
            <van-row class="border cell-body">
                <van-col span="8" class="title">收款周期</van-col>
                <van-col span="16" class="rightText pdr1">
                    <div>
                        <zwySelect
                            placeHolder="请选择收款周期"
                            @selectListItem="handleSelectCollectionPeriod"
                            :contentText="selectCollectionPeriod.text"
                            :arrow="true"
                        ></zwySelect>
                    </div>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell">
            <van-row class="border cell-body">
                <van-col span="8" class="title">签约日期</van-col>
                <van-col span="16" class="rightText pdr1" style="padding-right: 0;">
                    <div>
                        <zwy-date-picker
                            @dateChange="signDateChange($event)"
                            :title="'签约日期'"
                            :currentDate="signDate"
                            :arrow="true"
                        ></zwy-date-picker>
                    </div>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct' || (isPeriodicServiceBeta === 1 && currentType == 'buss' && serviceProperty == 1)" class="cell type">
            <van-row class="border cell-body">
                <van-col span="8" class="title">合同开始日期</van-col>
                <van-col span="16" class="rightText">
                    <date-picker
                        @dateChange="beginDateChange($event)"
                        :isRowPicker="true"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :title="'合同开始日期'"
                        :currentMonth="beginDate"
                    ></date-picker>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct' || (isPeriodicServiceBeta === 1 && currentType == 'buss' && serviceProperty == 1)" class="cell">
            <van-row class="border cell-body">
                <van-col span="8" class="title">合同结束日期</van-col>
                <van-col span="16" class="rightText">
                    <date-picker
                        @dateChange="endDateChange($event)"
                        :isRowPicker="true"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :title="'合同结束日期'"
                        :currentMonth="endDate"
                    ></date-picker>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct'" class="cell">
            <van-row class="border cell-body">
                <van-col span="8" class="title">赠送月份</van-col>
                <van-col span="16" class="rightText">
                  <multiplePeriod :monthRange="contractDateRange" :dataValue="multiplePeriodValue" @periodConfirm="periodConfirm" ></multiplePeriod>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct'" class="cell">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">月服务费</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="monthFee" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct'" class="cell">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">账本费</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="accountFee" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row :class="currentType == 'acct' ? 'cell' : 'cell type'">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">服务成本</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="serviceCost" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">其他成本</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="otherCost" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="currentType == 'acct'" class="cell">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">折扣金额</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="discount" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell" v-if="currentType == 'acct'">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">合同金额</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="contractAmount" disabled type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell" v-if="currentType == 'buss'">
            <van-row class="border cell-body receipts">
                <van-col span="8" class="title">合同金额</van-col>
                <van-col span="16" class="rightText">
                    <van-field v-model="contractAmount_buss" type="number" maxlength="11"/>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="cell type receipts">
            <van-row class="border cell-body">
                <van-col span="8" class="title">合同备注</van-col>
                <van-col span="16" class="rightText">
                    <van-field
                        v-model="contractReceipts"
                        @input="filterEmoji"
                        rows="1"
                        autosize
                        type="textarea"
                        maxlength="100"
                    />
                </van-col>
            </van-row>
        </van-row>
        <van-row v-if="env === 'miniprogram'" @click.native="sendToCheck" class="btnRow">完成新增合同</van-row>
        <van-row v-if="isNeedCheck && env === 'public'" @click.native="sendToCheck" class="btnRow">提交审核</van-row>
        <van-row v-if="!isNeedCheck && env === 'public'"  @click.native="setCollectionAmount"  class="btnRow">下一步：设置收款金额</van-row>
        <van-popup v-model="showServiceTypeList" position="bottom">
            <van-picker
                :default-index="serviceTypeIndex"
                v-if="serviceTypeOptions.length>0"
                show-toolbar
                title="服务类型"
                :columns="serviceTypeOptions"
                @cancel="showServiceTypeList = false"
                @confirm="confirmServiceType"
            />
            <div v-else class="noData">暂无服务类型</div>
        </van-popup>
        <van-popup v-model="showServiceItemList" position="bottom">
            <van-picker
                :default-index="0"
                v-if="serviceItemOptions.length>0"
                show-toolbar
                title="服务项目"
                :columns="serviceItemOptions"
                @cancel="showServiceItemList = false"
                @confirm="confirmServiceItem"
            />
            <div v-else class="noData">暂无服务项目</div>
        </van-popup>
        <van-popup v-model="showCollectionTypeList" position="bottom">
            <van-picker
                :default-index="0"
                v-if="collectionTypeOptions.length>0"
                show-toolbar
                title="收款方式"
                :columns="collectionTypeOptions"
                @cancel="showCollectionTypeList = false"
                @confirm="confirmCollectionType"
            />
            <div v-else class="noData">暂无收款方式</div>
        </van-popup>
        <van-popup v-model="showCollectionPeriodList" position="bottom">
            <van-picker
                :default-index="3"
                v-if="collectionPeriodOptions.length>0"
                show-toolbar
                title="收款周期"
                :columns="collectionPeriodOptions"
                @cancel="showCollectionPeriodList = false"
                @confirm="confirmCollectionPeriod"
            />
            <div v-else class="noData">暂无收款周期</div>
        </van-popup>
    </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon, Popup, Toast, Field, Picker } from "vant";
import DatePicker from "@/components/DatePicker.vue";
import ZwyDatePicker from "@/components/DateTimePicker.vue";
import zwySelect from "@/components/Select.vue";
import multiplePeriod from '@/components/multiplePeriod'
import moment from "moment";
import * as math from 'mathjs';
import wx from "weixin-js-sdk";
Vue.use(Row)
  .use(Col)
  .use(Icon)
  .use(Popup)
  .use(Field)
  .use(Picker);

export default {
  name: "addContract",
  components: { DatePicker, zwySelect, ZwyDatePicker, multiplePeriod },
  data() {
    return {
      isPeriodicServiceBeta: parseInt(sessionStorage.getItem('_isPeriodicServiceBeta')) || 0,
      minDate: new Date((new Date().getFullYear() - 20) + "/01/01") ,
      maxDate: new Date((new Date().getFullYear() + 20) +  "/12/31") ,
      currentType: this.$route.query.currentType,
      serviceProperty: this.$route.query.serviceProperty,
      serviceTypeIndex: parseInt(this.$route.query.serviceTypeIndex),
      customerName: "",
      customerId: "",
      connectName: "",
      connectPhone: "",
      //服务类型
      serviceTypeOptions: [],
      serviceTypeValue: 5,
      showServiceTypeList: false,
      selectServiceType: { text: "代理记账", value: 5 },
      //服务项目
      serviceItemOptions: [],
      serviceItemValue: 3,
      showServiceItemList: false,
      selectServiceItem: { text: "记账+报税", value: "3" },
      //收款方式
      collectionTypeOptions: [
        { value: 1, text: "先收款后服务" },
        { value: 2, text: "先服务后收款" }
      ],
      collectionTypeValue: 1,
      showCollectionTypeList: false,
      selectCollectionType: { text: "先收款后服务", value: 1 },
      //收款周期
      collectionPeriodOptions: [
        { value: 1, text: "按月收款" },
        { value: 2, text: "按季收款" },
        { value: 3, text: "按半年收款" },
        { value: 4, text: "按年收款" }
      ],
      collectionPeriodValue: 4,
      showCollectionPeriodList: false,
      selectCollectionPeriod: { text: "按年收款", value: 4 },
      beginDate:moment().format("YYYY-MM"),
      endDate: moment().add(11, 'months').format("YYYY-MM"),
      monthFee: "",
      accountFee: "",
      serviceCost: "",
      otherCost: "",
      contractReceipts: "",
      signDate:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 >= 10
          ? new Date().getMonth() + 1
          : "0" + (new Date().getMonth() + 1)) +
        "-" +
        (new Date().getDate() >= 10
          ? new Date().getDate()
          : "0" + new Date().getDate()),
      serviceTypeList: [],
      customerNameEdit: false,
      customerList: [],
      isNeedCheck: false,
      // contractAmount: '',
      contractAmount_buss:'',
      discount:'',
      contractDateRange: [],
      multiplePeriodValue:{},
      contractNo:'',
      customerNo:'',
      freeMonthCount:0,
      freeMonthStr:'',
      connectInputDisabled:false,
      canClick:true,
      env: 'public'
    };
  },
  watch: {
    selectServiceItem: {
      handler(val) {
        if(!val) {
          this.serviceCost = ""
          this.otherCost = ""
        } else {
          const { serviceCost, otherCost } = val;
          this.serviceCost = serviceCost
          this.otherCost = otherCost
        }
      },
      deep: true
    },
    customerName(newVal) {
      if (newVal != "") {
        // this.customerId = "";
        this.debounce(this.searchCustomer, 666);
      }
    },
    beginDate:{
      handler(newValue) {
        this.$set(this.contractDateRange, 0, moment(newValue).format('YYYY-MM'))
      },
      immediate: true,
      deep: true
    },
    endDate:{
      handler(newValue) {
        this.$set(this.contractDateRange, 1, moment(newValue).format('YYYY-MM'))
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    contractAmount() {
      let a = moment(this.beginDate);
      let b = moment(this.endDate);
      let bmonths = b.diff(a, "months") + 1;
      let result = ((bmonths - this.freeMonthCount)*(this.monthFee ? this.monthFee : 0) + parseInt(this.accountFee ? this.accountFee : 0) - parseInt(this.discount ? this.discount : 0)).toFixed(2);
      
      return result
    }
  },
  methods: {
    //js精度计算
    printFn(value) {
        const precision = 14
        return Number(math.format(value, precision))
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    init(data) {
      console.log(data, this.$route.query.serviceType, "serviceType");
      if(!this.$route.query.serviceType){
        return 
      }
      data &&
        data.length > 0 &&
        data.forEach(c => {
          if (c.serviceId == this.$route.query.serviceType) {

            this.selectServiceType = {
              text: c.serviceName,
              value: c.serviceId,
              serviceProperty: c.serviceProperty
            };

            this.serviceTypeValue = c.serviceId;
            this.getContractNo();

            this.serviceItemOptions =
              c.item &&
              c.item.length > 0 &&
              c.item.map(p => {
                return { text: p.itemName, value: p.itemId, serviceCost: p.serviceCost, otherCost: p.otherCost, serviceProperty: p.serviceProperty };
              });

            this.selectServiceItem = {
              text: c.item[0].itemName, 
              value: c.item[0].itemId,
              serviceCost: c.item[0].serviceCost,
              otherCost: c.item[0].otherCost,
              serviceProperty: c.item[0].serviceProperty
            };
            this.serviceProperty = this.selectServiceItem.serviceProperty
            this.serviceItemValue = c.item[0].itemId
          }
        });
    },
    setMonthfeeInfo(){
      let a = moment(this.beginDate);
      let b = moment(this.endDate);
      let bmonths = b.diff(a, "months") + 1;
      //计算实际月服务费，根据填写内容计算（小数点保留两位，第三位舍去，譬如166.6666，取为166.66）：[月服务费*（服务期限-赠送月份）-折扣金额]/（服务期限-赠送月份）
      let realityMonthfee = this.printFn((Number(this.monthFee)*(bmonths - this.freeMonthCount) - Number(this.discount))/(bmonths - this.freeMonthCount)) + '';
      console.log(this.monthFee,'this.monthFee')
      if(realityMonthfee && realityMonthfee.indexOf(".") != -1){
        realityMonthfee = realityMonthfee.substring(0,realityMonthfee.indexOf(".") + 3)
      }
      // 计算最后一个月的实际月服务费，合同期限中最后一个月的应收=月服务费*（服务期限-赠送月份）-折扣金额-实际月服务费*（服务期限-赠送月份-1），出现除不尽时（即最后一个月补尾差）
      let lastMonthFee = this.printFn(Number(this.monthFee)*(bmonths - this.freeMonthCount) - Number(this.discount) - realityMonthfee*(bmonths - this.freeMonthCount - 1)) + '';
      
      if(lastMonthFee && lastMonthFee.indexOf(".") != -1){
        lastMonthFee = lastMonthFee.substring(0,lastMonthFee.indexOf(".") + 3)
      }

      let freeMonthArray = this.freeMonthStr && this.freeMonthStr.slice(0,(this.freeMonthStr.length-1)).split(',');

      let realityMonthfeeInfo = {
        beginDate: this.beginDate,
        endDate: this.endDate,
        realityMonthfee: realityMonthfee,
        lastMonthFee: lastMonthFee,
        freeMonthArray: freeMonthArray
      }
      this.$store.dispatch("setRealityMonthfeeInfo", realityMonthfeeInfo);
    },
    //获取工商服务类型
    getBussTypeList() {
      this.$http
        .get("/fc/small/program/service/item")
        .then(res => {
          if (res.data.code == 200) {
            this.serviceTypeList = res.data.data || [];
            this.serviceTypeOptions =
              res.data.data &&
              res.data.data.length > 0 &&
              res.data.data.map(c => {
                return { text: c.serviceName, value: c.serviceId, serviceProperty: c.serviceProperty };
              });
            this.serviceItemOptions =
              res.data.data &&
              res.data.data.length > 0 &&
              res.data.data[0].item.length > 0 &&
              res.data.data[0].item.map(c => {
                return { text: c.itemName, value: c.itemId, serviceCost: c.serviceCost, otherCost: c.otherCost, serviceProperty: c.serviceProperty };
              });
            this.init(res.data.data);
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    //获取是否勾选合同需审核才能收款
    getIsNeedToCheck() {
      this.$http
        .get("/fc/small/program/check/conrenew?key=conRenewToFee")
        .then(res => {
          if (res.data.code == 200) {
            this.isNeedCheck = res.data.data;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    //获取合同编号，需要传给后端
    getContractNo() {
      let typeId = (this.currentType == 'acct' ?  1 : 2)
      this.$http
        .get("/fc/small/program/contract/contractno?serviceId=" + typeId)
        .then(res => {
          if (res.data.code == 200) {
            this.contractNo = res.data.data.contractNo;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    //获取客户编号，需要传给后端
    getCustomerNo() {
      this.$http
        .get("/fc/small/program/customer/customerNo?customerName=" + this.customerName)
        .then(res => {
          if (res.data.code == 200) {
            this.customerNo = res.data.data;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    summaryInfo(){

      let contractParams = {
        customerName: this.customerName, //公司名称
        contact:this.connectName,
        mobile:this.connectPhone,
        fax:this.connectPhone,
        customerId: this.customerId || 0,
        customerNo: this.customerNo, //客户编号
        contractNo: this.contractNo, //合同编号
        serviceId: this.serviceTypeValue, //服务类型
        itemId: this.serviceItemValue, //服务项目
        collectionWay: this.collectionTypeValue, //收款方式
        collectionPeriod: this.collectionPeriodValue,  //收款周期
        contractDate: this.signDate,  //合同签约日期
        // contractStartDate: this.beginDate + '-01', //合同开始日期
        // contractFinishDate: this.endDate + '-01', //合同结束日期
        contractFee: this.currentType == 'acct' ? this.contractAmount : this.contractAmount_buss, //合同金额
        discount:this.discount, //折扣金额
        giveMonth: this.freeMonthStr && this.freeMonthStr.slice(0,(this.freeMonthStr.length-1)),
        monthFee: this.monthFee, //月服务费
        yearFee: this.accountFee, //账本费
        serviceCost: this.serviceCost, //服务成本
        otherCost: this.otherCost,  //其它成本
        contractRemark: this.contractReceipts   //备注
      };

      if(this.currentType == 'acct' || (this.isPeriodicServiceBeta === 1 && this.currentType == 'buss' && this.serviceProperty == 1)){
        contractParams.contractStartDate = this.beginDate + '-01';
        contractParams.contractFinishDate = this.endDate + '-01';
      }

      return contractParams
    },
    setCollectionAmount() {
      if (!this.customerName.trim()) {
        Toast("请输入客户名称！");
        return;
      }
      if (!this.connectName.trim() && !this.connectInputDisabled) {
        Toast("请输入联系人！");
        return;
      }
      if (!this.connectPhone.trim() && !this.connectInputDisabled) {
        Toast("请输入联系电话！");
        return;
      }
      if (this.connectPhone && !(/^1[3456789]\d{9}$/.test(this.connectPhone))) {
        Toast("联系电话输入有误！");
        return;
      }
      if (!this.monthFee.trim() && this.currentType == 'acct') {
        Toast("请输入月服务费！");
        return;
      }
      if ((!this.contractAmount_buss || this.contractAmount_buss == 0) && this.currentType == 'buss') {
        Toast("请先填写合同金额！");
        return;
      }

      let contractParams = this.summaryInfo();

      let defaultParams = {currentType:this.currentType};

      let newParams = Object.assign({}, defaultParams, contractParams);

      this.$store.dispatch("setWechatCollectionInfo", newParams);

      this.$store.dispatch("setCollectionTypeInfo", {
        AmountList: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        discount: 0,
        serviceFee:0
      });

      this.$store.dispatch("setLackFeeAmount",0);

      this.$store.dispatch("setDueAmountDateInfo", {
        beginDate: "",
        endDate: ""
      });

      this.setMonthfeeInfo();
      
      this.$router.push({
        name: 'setCollectionAmount',
        query: newParams
      });
    },

    //服务类型
    handleServiceTypeChange(val) {
      this.serviceTypeValue = val.value;
      if (val.value == 5) {
        this.currentType = "acct";
      } else {
        this.currentType = "buss";
      }
      this.serviceTypeList &&
        this.serviceTypeList.length > 0 &&
        this.serviceTypeList.forEach(c => {
          if (c.serviceId == val.value) {
            this.selectServiceType = {
              text: c.serviceName,
              value: c.serviceId,
              serviceProperty: c.serviceProperty
            };
            this.serviceItemOptions =
              c.item &&
              c.item.length > 0 &&
              c.item.map(p => {
                return { text: p.itemName, value: p.itemId, serviceCost: p.serviceCost, otherCost: p.otherCost, serviceProperty: p.serviceProperty };
              });
            this.selectServiceItem = {
              text: c.item[0].itemName,
              value: c.item[0].itemId,
              serviceCost: c.item[0].serviceCost,
              otherCost: c.item[0].otherCost,
              serviceProperty: c.item[0].serviceProperty
            };
            this.serviceProperty = this.selectServiceItem.serviceProperty
            this.serviceItemValue = c.item[0].itemId
          }
        });
        this.getContractNo();
    },
    handleSelectServiceType() {
      this.showServiceTypeList = true;
    },
    confirmServiceType(value) {
      this.selectServiceType = value;
      this.handleServiceTypeChange(this.selectServiceType);
      this.showServiceTypeList = false;
    },

    //服务项目
    handleServiceItemChange(val) {
      this.serviceItemValue = val.value;
      this.serviceProperty = val.serviceProperty
    },
    handleSelectServiceItem() {
      this.showServiceItemList = true;
    },
    confirmServiceItem(value) {
      this.selectServiceItem = value;
      this.handleServiceItemChange(this.selectServiceItem);
      this.showServiceItemList = false;
    },

    //收款方式
    handleCollectionTypeChange(val) {
      this.collectionTypeValue = val;
    },
    handleSelectCollectionType() {
      this.showCollectionTypeList = true;
    },
    confirmCollectionType(value) {
      this.selectCollectionType = value;
      this.handleCollectionTypeChange(this.selectCollectionType.value);
      this.showCollectionTypeList = false;
    },

    //收款周期
    handleCollectionPeriodChange(val) {
      this.collectionPeriodValue = val;
    },
    handleSelectCollectionPeriod() {
      this.showCollectionPeriodList = true;
    },
    confirmCollectionPeriod(value) {
      this.selectCollectionPeriod = value;
      this.handleCollectionPeriodChange(this.selectCollectionPeriod.value);
      this.showCollectionPeriodList = false;
    },

    //模糊查询客户
    searchCustomer() {
      let url =
        "/fc/small/program/customere/list?page=1&limit=1000&orderProperty=createDate&orderDirection=asc";
      let params = {
        customerStatus: 0,
        type: 0
      };

      if (this.customerName.trim() != "") {
        params.customerName = this.customerName;
      }
      this.connectInputDisabled = false;
      this.connectName = '';
      this.connectPhone ='';

      this.$http
        .post(url, params)
        .then(res => {
          console.log(res, "/fc/small/program/customere/list");
          if (res.data.code == 200) {
            if(res.data.data.items && res.data.data.items.length == 1 && res.data.data.items[0].customerName === this.customerName){
              // this.customerNameEdit = false;
              this.customerId = res.data.data.items[0].customerId;
              this.connectName = res.data.data.items[0].contact;
              this.connectPhone = res.data.data.items[0].mobile;
              if(res.data.data.items[0].contact || res.data.data.items[0].mobile){
                this.connectInputDisabled = true;
              }
            }
            this.customerList = res.data.data.items;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(() => {
          // Toast('服务器错误！');
        });
    },
    beginSearch() {
      this.customerNameEdit = true;
    },
    endSearch() {
      setTimeout(() => {
        this.searchCustomer();
        this.getCustomerNo();
        this.customerNameEdit = false;
      }, 500);
    },
    selectCustomer(customer) {
      this.customerName = customer.customerName;
      this.customerId = customer.customerId;
      this.connectName = customer.contact;
      this.connectPhone = customer.mobile;
      if(customer.contact || customer.mobile){
        this.connectInputDisabled = true;
      }
    },
    beginDateChange(e) {
      this.beginDate = e;
      this.multiplePeriodValue = {}
    },
    endDateChange(e) {
      this.endDate = e;
      this.multiplePeriodValue = {}
    },
    signDateChange(e) {
      this.signDate = e;
    },
    filterEmoji() {
      // eslint-disable-next-line no-useless-escape
      let patt = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      this.receipts = this.receipts && this.receipts.replace(patt, "");
    },
    sendToCheck() {
      if (!this.customerName.trim()) {
        Toast("请输入客户名称！");
        return;
      }
      if (!this.connectName.trim() && !this.connectInputDisabled) {
        Toast("请输入联系人！");
        return;
      }
      if (!this.connectPhone.trim() && !this.connectInputDisabled) {
        Toast("请输入联系电话！");
        return;
      }
      if (this.connectPhone && !(/^1[3456789]\d{9}$/.test(this.connectPhone))) {
        Toast("联系电话输入有误！");
        return;
      }
      if (!this.monthFee.trim() && this.currentType == 'acct') {
        Toast("请输入月服务费！");
        return;
      }
      if(!this.canClick){
        Toast("请勿重复提交！");
        return
      }
      this.canClick = false;
      let contractParams = this.summaryInfo();
      let url = this.customerId
        ? "/fc/small/program/add/contract/customer/" + this.customerId
        : "/fc/small/program/add/contract";
      this.$http
        .post(url, contractParams)
        .then(res => {
          if (res.data.code === 200) {
            Toast("新增合同成功");
            this.$router.push({
              name: 'collectionHome',
            });
          } else {
            Toast(res.data.msg);
          }
          this.canClick = true;
        })
        .catch(() => {
          // Toast('服务器错误！');
          this.canClick = true;
        });
    },
    periodConfirm (data) {
      this.freeMonthCount = 0;
      this.freeMonthStr = '';
      this.multiplePeriodValue = data;
      this.computedFreeMonthsCount(data);
    },
    computedFreeMonthsCount(data){
      let yearArray = Object.keys(data);
      if(yearArray.length>0){
        yearArray.forEach(y=>{
          this.freeMonthCount += this.multiplePeriodValue[y].length
          this.multiplePeriodValue[y].forEach(m=>{
            this.freeMonthStr += (y + '-' + m) + ','
          })
        })
      }
      console.log(this.freeMonthCount,this.freeMonthStr,"freeMonthStrfreeMonthStrfreeMonthStrfreeMonthStr")
    },
    getRnv() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            this.env = "miniprogram";
          } else {
            this.env = "public";
          }
        });
      } else {
        this.env = "public";
      }
    },
  },
  mounted: function() {
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.getBussTypeList();
    this.getIsNeedToCheck();
    this.getRnv()
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.addContract {
    position: relative;
    padding-bottom: 0.64rem;

    .cell {
        background-color: #ffffff;
        font-size: 0.16rem;
        padding-left: 0.16rem;
        position: relative;
    }

    .cell-body {
        padding: 0.12rem;
        padding-left: 0;
    }

    .title {
        color: #1A2633;
        font-size: 0.17rem;
    }

    .rightText {
        text-align: right;
        color: #516374;
        font-size: 0.14rem;
        line-height: 0.23rem;
    }

    .leftText {
        color: #516374;
        font-size: 0.14rem;
    }

    .type {
        margin-top: 0.08rem;
    }

    .margnTop {
        margin-top: 0.1rem;
    }

    .task {
        color: #516374;
    }

    .pcolor {
        color: #1fadf6;
    }

    .border {
        border-bottom: 1px solid #f0f2f2;
    }

    .btnRow {
        padding: 0.16rem 0.12rem;
        text-align: center;
        color: #1FADF6;
        background-color: #ffffff;
        border-top: 1px solid #f0f2f2;
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        font-size: 0.17rem;
        box-sizing: border-box;
        font-weight: 500;
    }

    .btnRow.disabled {
        color: #B4BEC7;
    }

    .van-icon-arrow {
        margin-left: 0.04rem;
        position: relative;
        top: 0.02rem;
    }

    .pdr1 {
        padding-right: 0.18rem;
    }

    .customer-list {
        position: absolute;
        left: 0px;
        width: 3.75rem;
        top: 0.49rem;
        text-align: center;
        z-index: 1;
        background-color: #ffffff;
        box-sizing: border-box;
        max-height: 2rem;
        overflow: auto;
        box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    }

    .customer-item {
        line-height: 0.4rem;
        height: 0.4rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        border-bottom: 1px solid #f0f2f2;
        color: #1fadf6;
    }
}
</style>
<style>
.addContract .receipts .van-cell.van-field {
  padding: 0;
}
.addContract .content-text {
  width: auto;
}
.addContract .van-field__control {
  text-align: right;
  color: #516374;
}
</style>

